/* SUNBORN — Mobile PDP redesign JS (Captain-approved spec, 9/22; revised 9/28).
   Only does anything on product pages (body.template-product). Companion
   files: assets/sunborn-mobile-pdp-v2.css + the 9/28 mobile block in
   snippets/product-template-price.liquid.

   MOBILE LAYOUT (<=749px), per Captain 9/28:
     1. Title row:   "Product Title | ★★★★★ N Reviews"   (separator only
                     when the badge has 1+ reviews)
     2. ATC row:     [ $119.00 ~~$129.98~~ ]  [ ADD TO CART ]
                     [ Save $10.98 as a set ]
                     (price + strikeout stacked above the savings pill,
                     grouped to the LEFT of the ATC button — research-
                     backed "price on the ATC line" pattern)
     3. Installments line ("4 interest-free installments...") moved to sit
        BETWEEN the ATC row and the Buy with Shop button.
   Desktop is untouched.

   Every move leaves an invisible comment-node anchor at the element's
   original position, so crossing the 749px breakpoint in either direction
   (window resize, rotation) restores or reapplies cleanly, no reload. */
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isProductPage() {
    return document.body.classList.contains('template-product');
  }

  var anchors = {};          // name -> comment node at original position
  var reviewsObserver = null;
  var currentlyMobile = null;

  function anchorBefore(name, el) {
    if (!anchors[name]) {
      anchors[name] = document.createComment('sb-pdp-' + name + '-anchor');
      el.parentNode.insertBefore(anchors[name], el);
    }
  }

  function restore(name, el) {
    var a = anchors[name];
    if (el && a && a.parentNode) a.parentNode.insertBefore(el, a);
  }

  // ---- 1+2. Price box + savings pill -> stacked group left of ATC ----

  function movePriceToMobile() {
    var block = document.querySelector('.sb-pdp-price-block');
    var atcRow = document.querySelector('.sunborn-atc-row');
    if (!block || !atcRow || atcRow.querySelector('.sb-pdp-price-inline')) return;
    var priceBox = block.querySelector('.price-box');
    var saveRow = block.querySelector('.sb-save-row');
    if (!priceBox) return;

    anchorBefore('price', priceBox);
    if (saveRow) anchorBefore('save', saveRow);

    var wrap = document.createElement('span');
    wrap.className = 'sb-pdp-price-inline';
    wrap.appendChild(priceBox);
    if (saveRow) wrap.appendChild(saveRow);
    atcRow.insertBefore(wrap, atcRow.firstChild);
  }

  function movePriceToDesktop() {
    var wrap = document.querySelector('.sunborn-atc-row .sb-pdp-price-inline');
    if (!wrap) return;
    restore('price', wrap.querySelector('.price-box'));
    restore('save', wrap.querySelector('.sb-save-row'));
    wrap.remove();
  }

  // ---- 3. Installments line -> between ATC row and Buy with Shop ----

  function moveInstallmentToMobile() {
    var inst = document.querySelector('.sb-pdp-price-block form.installment');
    var atcRow = document.querySelector('.sunborn-atc-row');
    if (!inst || !atcRow) return;
    anchorBefore('installment', inst);
    inst.classList.add('sb-installment-mobile');
    atcRow.parentNode.insertBefore(inst, atcRow.nextSibling);
  }

  function moveInstallmentToDesktop() {
    var inst = document.querySelector('form.installment.sb-installment-mobile');
    if (!inst) return;
    inst.classList.remove('sb-installment-mobile');
    restore('installment', inst);
  }

  // ---- Reviews badge -> title row, with "|" separator ----
  // Waits for the script in product-template-price.liquid to finish
  // placing the hydrated Judge.me badge into .pro-prlb (that script owns
  // the hydration-timing logic) before relocating it.

  function reviewCount(badge) {
    var inner = badge && (badge.matches('.jdgm-prev-badge') ? badge : badge.querySelector('.jdgm-prev-badge'));
    var n = inner ? parseInt(inner.getAttribute('data-number-of-reviews') || '0', 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  function moveReviewsToMobile() {
    var priceInfo = document.querySelector('.sb-pdp-price-block .pro-prlb');
    var titleRow = document.getElementById('sb-pdp-title-row');
    if (!priceInfo || !titleRow) return;

    function tryMove() {
      var badge = priceInfo.querySelector('.jdgm-widget.jdgm-preview-badge');
      if (badge && badge.classList.contains('jdgm--done-setup')) {
        anchorBefore('badge', badge);
        if (reviewCount(badge) > 0 && !titleRow.querySelector('.sb-title-review-sep')) {
          var sep = document.createElement('span');
          sep.className = 'sb-title-review-sep';
          sep.setAttribute('aria-hidden', 'true');
          sep.textContent = '|';
          titleRow.appendChild(sep);
        }
        titleRow.appendChild(badge);
        fitTitle();
        return true;
      }
      return false;
    }

    if (tryMove()) return;

    if (reviewsObserver) reviewsObserver.disconnect();
    reviewsObserver = new MutationObserver(function () {
      if (tryMove()) {
        reviewsObserver.disconnect();
        reviewsObserver = null;
      }
    });
    reviewsObserver.observe(priceInfo, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    setTimeout(function () {
      if (reviewsObserver) {
        reviewsObserver.disconnect();
        reviewsObserver = null;
      }
      tryMove();
    }, 5500);
  }

  function moveReviewsToDesktop() {
    if (reviewsObserver) {
      reviewsObserver.disconnect();
      reviewsObserver = null;
    }
    var titleRow = document.getElementById('sb-pdp-title-row');
    var sep = titleRow && titleRow.querySelector('.sb-title-review-sep');
    if (sep) sep.remove();
    restore('badge', document.querySelector('#sb-pdp-title-row .jdgm-widget.jdgm-preview-badge'));
  }

  // ---- Title shrink-to-fit ----

  function fitTitle() {
    var el = document.getElementById('sb-pdp-title-text');
    if (!el) return;
    var size = 19;
    el.style.fontSize = size + 'px';
    while (el.scrollWidth > el.clientWidth && size > 9) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
  }

  function clearTitleFit() {
    var el = document.getElementById('sb-pdp-title-text');
    if (el) el.style.fontSize = '';
  }

  // ---- Apply/revert on load and on every breakpoint crossing ----

  function applyForCurrentWidth() {
    if (!isProductPage()) return;
    var mobile = isMobile();
    if (mobile === currentlyMobile) {
      if (mobile) fitTitle();
      return;
    }
    if (mobile) {
      movePriceToMobile();
      moveInstallmentToMobile();
      moveReviewsToMobile();
      fitTitle();
    } else {
      movePriceToDesktop();
      moveInstallmentToDesktop();
      moveReviewsToDesktop();
      clearTitleFit();
    }
    currentlyMobile = mobile;
  }

  document.addEventListener('DOMContentLoaded', applyForCurrentWidth);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyForCurrentWidth, 150);
  });
})();
